import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';
import { redListedCompanyKeys } from './redListedCompanies.key';

type Options = {
  onDeleteQuestionSuccess?: () => void;
  onDeleteQuestionError?: (error: unknown) => void;
};

export function useDeleteRedListed(options?: Options) {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const deleteRedListed = async (redListedId: string) => {
    const api = await getApi();

    const res = await api.redListedCompaniesDeleteRedListedCompany(redListedId);
    return res.data;
  };

  const onSuccess = () => {
    toast.success('Bolaget har raderats');
    queryClient.invalidateQueries({
      queryKey: redListedCompanyKeys.redlistedCompanies,
    });
    options?.onDeleteQuestionSuccess?.();
  };

  const onError = (error: unknown) => {
    toast.error('Error, bolaget gick inte att radera');
    options?.onDeleteQuestionError?.(error);
  };

  const mutation = useMutation(deleteRedListed, {
    onError,
    onSuccess,
  });

  return mutation;
}
